var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoiActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.703,
    height: 21.702,
    viewBox: "0 0 21.703 21.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.637,
    y1: 0.416,
    x2: 1.47,
    y2: 0.416,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3416b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e45f48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.003,
    y1: 0.502,
    x2: 0.999,
    y2: 0.502,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.038,
    y1: 0.513,
    x2: 1.015,
    y2: 0.513,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coi_active",
    transform: "translate(-1.198 -1.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_93798",
    "data-name": "\\uADF8\\uB8F9 93798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000006672389563517902010000007233559274862589111_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86808",
    "data-name": "\\uD328\\uC2A4 86808",
    d: "M14.8,7.8c0-.1-.1-.1-.1-.2C14.8,7.7,14.8,7.7,14.8,7.8Z",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000062176225718970792020000004388109112369003191_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000083809376503348372000000007675508967415865496_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_93797",
    "data-name": "\\uADF8\\uB8F9 93797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86809",
    "data-name": "\\uD328\\uC2A4 86809",
    d: "M12,1.3A10.777,10.777,0,0,0,1.2,12.2,10.777,10.777,0,0,0,12.1,23,10.777,10.777,0,0,0,22.9,12.1,10.9,10.9,0,0,0,12,1.3ZM10.6,11.7a1.9,1.9,0,1,1,1.9-1.9A1.967,1.967,0,0,1,10.6,11.7Zm1.5,2.1h0a4.075,4.075,0,0,0,1.8.5,6.154,6.154,0,0,0,1.9-.2,6.971,6.971,0,0,0,1.9-.6,4.671,4.671,0,0,0,1-.5h0a2.092,2.092,0,0,0,.6-.4l.1-.1h0a9.908,9.908,0,0,1-1.7,1.1,10.662,10.662,0,0,1-1.9.7,4.421,4.421,0,0,1-2,.2A2.51,2.51,0,0,1,12.1,13.8Zm5-2.1a.4.4,0,1,1,.4.4A.43.43,0,0,1,17.1,11.7ZM13.8,22.1c-.4-2.9,2.2-5.8,3.6-7.3l1.3-1.3c1.9-1.8,2.3-3.9-1.6-4.9-.7-.2-1.5-.5-2.3-.8,0-.1-.1-.1-.1-.2a1.18,1.18,0,0,0-.5-.5,2.9,2.9,0,0,0-2.3-.2,5.769,5.769,0,0,0-2.6-.1c-3.7,1-4.3,2.8-4.5,5a16.989,16.989,0,0,1-1.2,6.1A10.058,10.058,0,0,1,11.8,2.1a10.116,10.116,0,0,1,10.1,10A9.839,9.839,0,0,1,13.8,22.1Z",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000078724336358560829600000012381213710450126469_",
    d: "M11.9,9.7a1.4,1.4,0,1,1-1.4-1.4A1.5,1.5,0,0,1,11.9,9.7Z",
    fill: "url(#linear-gradient-3)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoiActive);
export default __webpack_public_path__ + "static/media/coi_active.58cb8b9f617cca675171028c49db3a99.svg";
export { ForwardRef as ReactComponent };